import React from 'react';
import InstagramIcon from '@mui/icons-material/Instagram';
import MarkunreadIcon from '@mui/icons-material/Markunread';
import TwitterIcon from '@mui/icons-material/Twitter';

const SocialMediaIcons = () => {
  return (
    <div className='flex justify-between gap-[8px] flex-col items-center h-auto w-auto fixed bottom-[50%] right-[20px] '>
      <a
        href='https://www.instagram.com/wootlabfoundation/'
        target='_blank'
        className='bg-[rgb(251,189,57)] p-[5px] rounded-[50px]'
      >
        <InstagramIcon className='text-white' />
      </a>
      <a
        href='mailto:hello@wootlab.ng'
        target='_blank'
        className='bg-[rgb(251,189,57)] p-[5px] rounded-[50px]'
      >
        <MarkunreadIcon className='text-white' />
      </a>
      <a
        href='https://twitter.com/Wootfoundation'
        target='_blank'
        className='bg-[rgb(251,189,57)] p-[5px] rounded-[50px]'
      >
        <TwitterIcon className='text-white' />
      </a>
    </div>
  );
};

export default SocialMediaIcons;
